import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
	plugins: [createPersistedState()],
	state: {
		register: true,
		user: {
			loggedIn: false,
			data: null,
			additionalData: null,
			token: null,
			apiData: null,
			adminData: null,
		},
		error: null,
	},
	getters: {
		user(state) {
			return state.user;
		},
		error(state) {
			return state.error;
		},
	},
	mutations: {
		formSwitch(state) {
			return (state.register = !state.register);
		},
		formReg(state) {
			return (state.register = true);
		},
		formLogin(state) {
			return (state.register = false);
		},
		SET_LOGGED_IN(state, value) {
			state.user.loggedIn = value;
		},
		SET_USER(state, data) {
			state.user.data = data;
		},
		SET_ADD_DATA(state, data) {
			state.user.additionalData = data;
		},
		SET_TOKEN(state, data) {
			state.user.token = data;
		},
		SET_API_DATA(state, data) {
			state.user.apiData = data;
		},
		SET_ADMIN_DATA(state, data) {
			state.user.adminData = data;
		},
		SET_ERROR(state, data) {
			state.error = data;
		},
		DROP_ERROR(state) {
			state.error = null;
		},
		DROP_ADMIN_DATA(state) {
			state.user.adminData = null;
		},
	},
	actions: {
		fetchUser({ commit }, user) {
			commit("SET_LOGGED_IN", user !== null);
			if (user) {
				commit("SET_USER", {
					uid: user.uid,
					displayName: user.displayName,
					email: user.email,
					emailVerified: user.emailVerified,
					uid: user.uid,
				});
			} else {
				commit("SET_USER", null);
				commit("SET_ADD_DATA", null);
				commit("SET_API_DATA", null);
				commit("SET_TOKEN", null);
				commit("DROP_ADMIN_DATA", null);
			}
		},
		setToken({ commit }, token) {
			commit("SET_TOKEN", token);
		},
		setError({ commit }, error) {
			commit("SET_ERROR", error);
		},
		setApiData({ commit }, data) {
			commit("SET_API_DATA", data);
		},
		setAdminData({ commit }, data) {
			commit("SET_ADMIN_DATA", data);
		},
		dropAdminData({ commit }) {
			commit("DROP_ADMIN_DATA");
		},
	},
	modules: {},
});
